import { writable, derived, get } from 'svelte/store';

export const user = writable(null);
export const isLoggedIn = derived(user, $u => !!$u);

export async function initAuth() {
  try {
    const data = await apiFetch('/users/me');
    user.set(data);
  } catch {
    user.set(null);
  }
}

export async function login(email, password) {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  user.set(data.user);
  return data;
}

export async function logout() {
  try {
    await apiFetch('/auth/logout', { method: 'POST' });
  } finally {
    user.set(null);
  }
}

export async function maybeRefresh() {
  const u = get(user);
  if (!u?.exp) return;

  const secondsLeft = u.exp - Math.floor(Date.now() / 1000);
  const twelveHours = 12 * 60 * 60;

  if (secondsLeft < twelveHours) {
    try {
      await apiFetch('/auth/refresh', { method: 'POST' });
      // Re-fetch /users/me so exp in the store stays current
      const fresh = await apiFetch('/users/me');
      user.set(fresh);
    } catch {
      // Non-fatal
    }
  }
}

export async function apiFetch(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const res = await fetch('/api' + path, {
    ...options,
    credentials: 'include',
    headers,
  });

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    const message = body?.error || body?.message || res.statusText || 'Request failed';
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const text = await res.text();
  return text ? JSON.parse(text) : null;
}
